/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Fade from "@mui/material/Fade";

// Material Dashboard 2 React base styles
import colors from "assets/theme/base/colors";
import typography from "assets/theme/base/typography";
import borders from "assets/theme/base/borders";

// Material Dashboard 2 React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { ink, white } = colors;
const { size, fontWeightRegular } = typography;
const { borderRadius } = borders;

// Redesign: solid ink tooltip, 12px, small radius (single restrained overlay style).
const tooltip = {
  defaultProps: {
    arrow: true,
    TransitionComponent: Fade,
  },

  styleOverrides: {
    tooltip: {
      maxWidth: pxToRem(240),
      backgroundColor: ink.main,
      color: white.main,
      fontSize: size.xs,
      fontWeight: fontWeightRegular,
      textAlign: "center",
      borderRadius: borderRadius.sm,
      opacity: 1,
      padding: `${pxToRem(6)} ${pxToRem(10)}`,
    },

    arrow: {
      color: ink.main,
    },
  },
};

export default tooltip;
